import angularModule from 'Authentication/angularModule/scripts/authentication_module';
import Auid from 'Auid';
import moment from 'moment-timezone';
import { preSignupValues } from 'TinyEventLogger';

angularModule.factory('omniauth', [
    '$injector',
    $injector => {
        const AuthClient = $injector.get('AuthClient');
        const ConfigFactory = $injector.get('ConfigFactory');
        const $window = $injector.get('$window');
        const reactRouterBridge = $injector.get('reactRouterBridge');
        const Locale = $injector.get('Locale');
        const $q = $injector.get('$q');
        const ClientStorage = $injector.get('ClientStorage');
        const ClientConfig = $injector.get('ClientConfig');
        const clientConfig = ClientConfig.current;
        const $rootScope = $injector.get('$rootScope');
        const safeApply = $injector.get('safeApply');

        return {
            loginWithProvider(provider, signUpCode, programType) {
                return ConfigFactory.getConfig()
                    .then(config => {
                        /*
                        For clients that don't want to support the sp-initiated auth flow
                        we just forward to the idp-initiated flow
                        rather than going with the sp-initiated flow.

                        FIXME: this appears to be broken. See details in
                        docs/oauth_login.md#SAML (entry #3 in the list)
                    */
                        const idpUrl = config.forceIdpInitiatedLoginUrlFor(provider);
                        if (idpUrl) {
                            $window.location.href = idpUrl;

                            // At this point, we expect to leave the front-royal app, we return a
                            // promise that will never resolve in order to prevent the auth
                            // call from ever being complete
                            return $q(() => {});
                        }
                        const params = {
                            origin: $window.location.href,
                            sign_up_code: signUpCode,
                            pref_locale: Locale.defaultLocaleForSignUpCode(signUpCode),
                            timezone: moment.tz.guess(),
                            cloudflare_country_code: $window.cloudflareCountryCode,
                        };

                        if ($window.preSignupForm?.phone) params.phone = $window.preSignupForm.phone;

                        const id = Auid.get($rootScope.currentUser);
                        if (id) params.id = id;

                        if (programType) params.program_type = programType;

                        // pull skip_apply from the query params (if available) and pass up to the server
                        const skip_apply = reactRouterBridge.search() && reactRouterBridge.search().skip_apply;
                        if (skip_apply) params.skip_apply = skip_apply;

                        // pull the user id stored from a referral link (if available) and pass up to the server
                        const referredById = ClientStorage.getItem('referredById');
                        if (referredById) params.referred_by_id = referredById;

                        // append the client config since this will be accessed via a hard link resolution
                        // and will not be subject to angular interceptors
                        params.fr_client = clientConfig.identifier;

                        // add the dynamic landing page multi-step pre-signup form to the params
                        // FIXME: See if this is still necessary
                        Object.assign(params, preSignupValues.allServer());

                        return AuthClient.initiateOmniauth(provider, params);
                    })
                    .finally(() => {
                        safeApply($rootScope);
                    });
            },
        };
    },
]);
